import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Link from 'next/link';

var SubMenu = function SubMenu(_ref) {
  var options = _ref.options,
      selected = _ref.selected;
  return /*#__PURE__*/_jsx("div", {
    className: "s-menu",
    children: /*#__PURE__*/_jsx("ul", {
      children: options.map(function (option, index) {
        if (option.name === selected) {
          return /*#__PURE__*/_jsx("li", {
            className: "selected",
            children: /*#__PURE__*/_jsx(Link, {
              href: option.href,
              children: /*#__PURE__*/_jsx("a", {
                children: option.name
              })
            })
          }, index);
        }

        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Link, {
            href: option.href,
            children: /*#__PURE__*/_jsx("a", {
              children: option.name
            })
          })
        }, index);
      })
    })
  });
};

export default SubMenu;